var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("h3", { staticClass: "mobile-only" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.t("lead.question_contact_mobile")) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("lead.question_fullname"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.fullname,
                  expression: "fullname",
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "fullname-txt",
                fieldTitle: _vm.t("lead.question_fullname", {}, "zh"),
                fieldValue: _vm.fullname,
                fieldname: "fullname",
                fieldType: "name",
                name: "fullname",
                type: "text",
              },
              domProps: { value: _vm.fullname },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.fullname = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("lead.question_phone"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.mobile,
                  expression: "mobile",
                },
              ],
              staticClass: "form-control",
              attrs: {
                fieldTitle: _vm.t("lead.question_phone", {}, "zh"),
                fieldValue: _vm.mobile,
                fieldType: "mobile",
                fieldname: "mobile",
                fieldAttrs: "unique",
                name: "mobile",
                type: "tel",
                maxlength: "8",
                minlength: "8",
                readonly: "true",
              },
              domProps: { value: _vm.mobile },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.mobile = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
            _c("label", { staticClass: "inbox-label required" }, [
              _vm._v(_vm._s(_vm.t("common.email"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email",
                },
              ],
              staticClass: "form-control",
              attrs: {
                fieldTitle: _vm.t("common.email", {}, "zh"),
                fieldValue: _vm.email,
                fieldname: "email",
                fieldType: "email",
                required: "",
                name: "email",
                type: "email",
                id: "id_email",
              },
              domProps: { value: _vm.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.type !== "commercial_loan" &&
          _vm.type != "mortgage" &&
          _vm.requireHKID
            ? _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                _c("label", { staticClass: "inbox-label required" }, [
                  _vm._v(_vm._s(_vm.t("lead.question_id"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.realIdentity,
                      expression: "realIdentity",
                    },
                  ],
                  staticClass: "form-control hkid-input",
                  attrs: {
                    id: "realIdentity",
                    placeholder: _vm.t("lead.question_id_tips"),
                    fieldTitle: _vm.t("lead.question_id", {}, "zh"),
                    fieldname: "realIdentity",
                    fieldType: "hkid",
                    fieldAttrs: "unique",
                    name: "realIdentity",
                    type: "text",
                    maxlength: "9",
                    minlength: "8",
                    required: "",
                  },
                  domProps: { value: _vm.realIdentity },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.realIdentity = $event.target.value
                    },
                  },
                }),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.type !== "commercial_loan" && _vm.type !== "mortgage"
        ? _c("section", [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                  _c("label", { staticClass: "inbox-label required" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.t("register.birthdate")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("IntegerInput", {
                          attrs: {
                            label: _vm.t("application.employment_tenor_years"),
                            id: "birthdate_year",
                            required: "",
                          },
                          on: { change: _vm.birthdateYearChange },
                          model: {
                            value: _vm.birthdateYear,
                            callback: function ($$v) {
                              _vm.birthdateYear = $$v
                            },
                            expression: "birthdateYear",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("IntegerInput", {
                          attrs: {
                            label: _vm.t("application.employment_tenor_months"),
                            id: "birthdate_month",
                            required: "",
                          },
                          on: { change: _vm.birthdateMonthChange },
                          model: {
                            value: _vm.birthdateMonth,
                            callback: function ($$v) {
                              _vm.birthdateMonth = $$v
                            },
                            expression: "birthdateMonth",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("IntegerInput", {
                          attrs: {
                            label: _vm.t("application.employment_tenor_days"),
                            id: "birthdate_day",
                            required: "",
                          },
                          on: { change: _vm.birthdateDayChange },
                          model: {
                            value: _vm.birthdateDay,
                            callback: function ($$v) {
                              _vm.birthdateDay = $$v
                            },
                            expression: "birthdateDay",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                  _c("label", { staticClass: "inbox-label d-block" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.t("register.gender")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "radio-group",
                      staticStyle: { "margin-bottom": "0px" },
                      attrs: { id: "has-loan-radios" },
                    },
                    [
                      _c("label", { staticClass: "btn-radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.gender,
                              expression: "gender",
                            },
                          ],
                          attrs: {
                            name: "gender",
                            type: "radio",
                            value: "male",
                            fieldTitle: "性別",
                            fieldName: "gender",
                            fieldValue: _vm.gender,
                          },
                          domProps: { checked: _vm._q(_vm.gender, "male") },
                          on: {
                            change: function ($event) {
                              _vm.gender = "male"
                            },
                          },
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.t("register.male")) +
                            " "
                        ),
                      ]),
                      _c("label", { staticClass: "btn-radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.gender,
                              expression: "gender",
                            },
                          ],
                          attrs: {
                            name: "gender",
                            type: "radio",
                            value: "female",
                            fieldTitle: "性別",
                            fieldName: "gender",
                            fieldValue: _vm.gender,
                          },
                          domProps: { checked: _vm._q(_vm.gender, "female") },
                          on: {
                            change: function ($event) {
                              _vm.gender = "female"
                            },
                          },
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("register.female")) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("label", { staticClass: "inbox-label" }, [
                      _vm._v(_vm._s(_vm.t("application.accommodation"))),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.accommodationOptions,
                        searchable: false,
                        name: "typeOfAccommodation",
                        fieldTitle: "居所類型",
                        fieldName: "typeOfAccommodation",
                        fieldValue: _vm.typeOfAccommodation
                          ? _vm.typeOfAccommodation.value
                          : "",
                      },
                      model: {
                        value: _vm.typeOfAccommodation,
                        callback: function ($$v) {
                          _vm.typeOfAccommodation = $$v
                        },
                        expression: "typeOfAccommodation",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("label", { staticClass: "inbox-label" }, [
                      _vm._v(_vm._s(_vm.t("application.personal_status"))),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.personalStatus,
                        searchable: false,
                        name: "personal-status",
                        fieldTitle: "婚姻狀況",
                        fieldName: "maritalStatus",
                        fieldValue: _vm.maritalStatus
                          ? _vm.maritalStatus.value
                          : "",
                      },
                      model: {
                        value: _vm.maritalStatus,
                        callback: function ($$v) {
                          _vm.maritalStatus = $$v
                        },
                        expression: "maritalStatus",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type !== "commercial_loan" && _vm.refreshIdentity
        ? _c("Identity", {
            attrs: {
              bornInHK: _vm.bornInHK,
              permanent: _vm.permanent,
              validityPeriod: _vm.validityPeriod,
              showAge: _vm.showAge,
              inviteCode: _vm.inviteCode,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "commercial_loan"
        ? _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
            _c("label", { staticClass: "inbox-label" }, [
              _vm._v(_vm._s(_vm.t("application.invitation_code"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inviteCode,
                  expression: "inviteCode",
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "invCode-txt",
                fieldTitle: _vm.t("application.invitation_code", {}, "zh"),
                fieldValue: _vm.inviteCode,
                fieldname: "inviteCode",
                name: "inviteCode",
                type: "text",
                maxlength: "300",
              },
              domProps: { value: _vm.inviteCode },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.inviteCode = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "age", fieldname: "age" },
        domProps: { value: _vm.age },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "identity", fieldname: "identity" },
        domProps: { value: _vm.identity },
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.birthdate,
            expression: "birthdate",
          },
        ],
        staticClass: "form-control datepicker full-width",
        attrs: {
          id: "id_birthdate",
          name: "birth_date",
          type: "hidden",
          placeholder: "yyyy-mm-dd",
          fieldTitle: "出生日期",
          fieldName: "birthdate",
        },
        domProps: { value: _vm.birthdate },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.birthdate = $event.target.value
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }